exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-btn {\n  position: absolute;\n  top: 0;\n  right: 10px;\n  z-index: 100; }\n\n.errors {\n  font-family: 'Roboto', sans-serif;\n  color: #E55049; }\n\nmd-dialog-content {\n  font-family: 'Roboto', sans-serif;\n  padding: 0 12px; }\n\n.vertical-center {\n  margin-top: -18px; }\n\n.center-content {\n  padding-left: 14px;\n  padding-right: 14px; }\n  .center-content .col-md-6 {\n    padding: 0; }\n\n.date-placeholder {\n  width: 85px;\n  font-size: 14px;\n  float: left;\n  margin-top: -2px; }\n  .date-placeholder:hover {\n    background-color: #F4F8FA; }\n\n.date-placeholder-label {\n  float: left;\n  margin-top: -4px;\n  margin-right: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios/filters-precios-dialog.component.scss
// module id = ../../../../../src/app/components/precios-seccion/precios/filters-precios-dialog.component.scss
// module chunks = 0